import { render, staticRenderFns } from "./oneSoftWare.vue?vue&type=template&id=4b58efaa&scoped=true"
import script from "./oneSoftWare.vue?vue&type=script&lang=js"
export * from "./oneSoftWare.vue?vue&type=script&lang=js"
import style0 from "./oneSoftWare.vue?vue&type=style&index=0&id=4b58efaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b58efaa",
  null
  
)

export default component.exports